export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7484.746bae1a.jpg";